import { useQuery, useMutation } from "react-query";
import axios from "../../axiosConfig/axios";

const getTemplates = async (templateType,userToken) => {
    const { data } = await axios.get('email_templates/search',{
        params: {
            type: templateType
        },
        headers: {
            Authorization: userToken
        }
    })
    return data
}
const sendInvite = async (data) => {
    let body = {
        emails: data.emails,
        templateId: data.templateId
    }
    const { resdata } = await axios.post('admin/invite',body,{
        headers: {
            Authorization: data.token
        }
    })
    return resdata
}
const updateTemplate = async (data) => {
    let body = {
        subject: data.subject,
        body: data.body
    }
    const { resdata } = await axios.patch('email_templates',body,{
        params: {
            template_id: data.templateId
        },
        headers: {
            Authorization: data.token
        }
    })
    return resdata
}
export default {
    useTemplates(templateType,userToken) { 
        return useQuery(["templates",templateType,userToken], () => getTemplates(templateType,userToken),{staleTime: 10000})
    },
    useInvite() {
        return useMutation((data) => {
            return sendInvite(data)
        })
    },
    useTemplate() {
        return useMutation((data,userToken,templateId) => {
            return updateTemplate(data)
        })
    }
}